// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// Components Imports
import AssetDetailsModal from "./AssetDetailsModal";
import AssetDetailsDropdown from "./AssetDetailsDropdown";

class AssetDetailsPopupWrapper extends Component {
  state = {
    showAssetDetailsModal: false,
  };

  _showAssetDetailsModalHandler = () => {
    this.setState({ showAssetDetailsModal: true });
  };

  _closeAssetDetailsModalHandler = () => {
    this.setState({ showAssetDetailsModal: false });
  };

  render() {
    const {
      show,
      opportunity: { id: oppID },
      isFetch,
      opportunityByID,
    } = this.props;
    let decideView = null;
    const decideOpp = isFetch ? opportunityByID : this.props.opportunity;

    if (this.state.showAssetDetailsModal && !show) {
      decideView = (
        <AssetDetailsModal
          opportunity={decideOpp}
          show={this.state.showAssetDetailsModal}
          closePopup={this._closeAssetDetailsModalHandler}
        />
      );
    } else if (!this.state.showAssetDetailsModal && show) {
      decideView = (
        <AssetDetailsDropdown
          assetDetailDropdownRef={this.props.assetDetailDropdownRef}
          showAssetDetailsModalHandler={this._showAssetDetailsModalHandler}
          positionClassName={this.props.positionClassName}
          oppID={oppID}
          opportunity={decideOpp}
          isFetch={isFetch}
        />
      );
    }

    return <Fragment>{decideView}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { opportunityByID } = state.PipelineStore;
  return {
    opportunityByID,
  };
};

export default connect(mapStateToProps)(AssetDetailsPopupWrapper);
